module.exports = __webpack_public_path__ + "static/media/track_start.00b1de1f.png";